// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1fnJb","logo":"Header_logo___5YQx","headerinput":"Header_headerinput__3iVDR"};